const mandatoryFields = ['phone', 'user_id'];

export default mandatoryFields;
